var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event"},[_c('a-timeline',{attrs:{"mode":"alternate"}},_vm._l((_vm.evs),function(ev,index){return _c('a-timeline-item',{key:'ev' + index},[_c('span',[_vm._v(_vm._s(ev.time))]),_vm._v(_vm._s(ev.name)+"\n    ")])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }